
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms-and-conditions-page",
      function () {
        return require("private-next-pages/terms-and-conditions-page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms-and-conditions-page"])
      });
    }
  